import sendRejectBenefitRequest from "v2/infrastructure/BenefitRequests/repositories/sendRejectBenefitRequest";

const rejectBenefitRequest = ({
  companyId,
  requestId,
  reason,
}: {
  companyId: string;
  requestId: string;
  reason: string;
}) => {
  return sendRejectBenefitRequest({ companyId, requestId, reason });
};

export default rejectBenefitRequest;
